import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getResults } from './api';
import { ResultsSliceState, SolutionRequestProps } from './interfaces';

const initialState: ResultsSliceState = {
  isResultsLoading: 'idle',
  solution: null,
};

export const fetchResults = createAsyncThunk('results/fetchResults', async (solutionRequest: SolutionRequestProps) => {
  const response = await getResults(solutionRequest);
  return response;
});

export const resultsSlice = createSlice({
  name: 'results',
  initialState,
  reducers: {
    cleanResults: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchResults.pending, (state) => {
      state.isResultsLoading = 'pending';
    });
    builder.addCase(fetchResults.fulfilled, (state, action) => {
      state.solution = action.payload;
      state.isResultsLoading = 'success';
    });
    builder.addCase(fetchResults.rejected, (state) => {
      state.isResultsLoading = 'error';
    });
  },
});

export const { cleanResults } = resultsSlice.actions;

export default resultsSlice.reducer;
